import { RegisterReceiptData } from './../../../../../../store/models/register.model';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { PageState } from '../../../../../../store/models/page.model';
import { setBannerComponent } from '../../../../../../store/actions/page.action';

@Component({
  selector: 'app-register-step-receipt',
  templateUrl: './register-step-receipt.component.html',
  styleUrls: ['./register-step-receipt.component.scss'],
})
export class RegisterStepReceiptComponent implements OnInit {
  @Input() paymentData: RegisterReceiptData;

  @Output() Continue = new EventEmitter<any>();

  constructor(private store: Store<PageState>) {
    this.store.dispatch(
      setBannerComponent({ banner: 'Success', subtitle: 'Payment Completed' }),
    );
  }

  onContinue = () => {
    this.Continue.emit(true);
  };

  ngOnInit() {
    window.scroll(0, 0);
  }

  generateCardNumber() {
    return (
      Array.from(Array(12).values())
        .map(item => (item = '*'))
        .join('') + this.paymentData.payment_data.card_last_4
    );
  }

  toInt(value: string): number {
    return parseInt(value, 10);
  }

  toFloat(value: number): string {
    return value.toFixed(2);
  }
}
